<template>
	<div v-if="isMounted">
		<GroupTopBar :notFound="notFound" :group="localGroup" />
		<GroupHeading :group="localGroup" :hasEditPermissions="canManageGroups" />
		<AppTabs class="pt-7" :tabItems="tabItems" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import GroupTopBar from '@/components/Settings/groups/GroupTopBar';
import GroupHeading from '@/components/Settings/groups/GroupHeading';
import SyncedGroupOptionsTab from './tabs/SyncedGroupOptionsTab';
import GroupMembersTab from './tabs/GroupMembersTab';
import GroupPermissionsTab from './tabs/GroupPermissionsTab';

import { AccountPermissions } from '@ply-io/ply-front-shared-utilities';

import { hasAccountPermission } from '@/store/modules/account/getters';
import { getGroups, createGroup, updateGroup, setSelectedGroup } from '@/store/modules/accountGroups/actions';
import { groups, selectedGroup } from '@/store/modules/accountGroups/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'ManageSingleGroup',
	components: {
		GroupTopBar,
		GroupHeading,
	},
	props: {
		groupId: { type: Number },
	},
	computed: {
		...mapGettersShorthand({ hasAccountPermission, groups, selectedGroup }),
		canManageGroups() {
			return this.hasAccountPermission(AccountPermissions.ManageGroups);
		},
		localGroup() {
			return this.selectedGroup;
		},
		tabItems() {
			const tabs = [
				{ tab: 'Members', title: 'Members', component: GroupMembersTab, props: { group: this.localGroup }, disabled: false },
				{
					tab: 'SyncedGroupOptions',
					title: 'Synced group options',
					component: SyncedGroupOptionsTab,
					props: { group: this.localGroup },
					disabled: this.localGroup?.type !== 'synced' || !this.canManageGroups,
				},
				{
					tab: 'Permissions',
					title: 'Permissions',
					component: GroupPermissionsTab,
					props: { group: this.localGroup },
					disabled: !this.canManageGroups,
				},
			];
			return tabs.filter((x) => !x.disabled);
		},
	},
	methods: {
		...mapActions([getGroups.fullPath, createGroup.fullPath, updateGroup.fullPath, setSelectedGroup.fullPath]),
	},
	async mounted() {
		this[getGroups.fullPath]();
		if (!this.groupId) {
			return;
		}

		const selected = this.groups.filter((x) => x.id === this.groupId);
		if (selected.length === 0) {
			this.notFound = true;
		} else {
			this[setSelectedGroup.fullPath](selected[0]);
		}
		this.isMounted = true;
	},
	beforeDestroy() {
		this[setSelectedGroup.fullPath](null);
	},
	data: () => ({
		searchString: '',
		notFound: false,
		isMounted: false,
	}),
};
</script>

<style scoped lang="scss">
h4.reg {
	font-weight: 500 !important;
}
.group-body {
	height: 50vh;

	.group-details {
	}
}
</style>
